<template>
    <div>
        <v-row>
            <v-col cols="12">
                <v-card color="yellow lighten-3">
                    <v-row align="center" >
                        <v-col cols="6" class="">
                            <v-card-title>
                                Researcher Draft
                            </v-card-title>
                            <v-card-subtitle v-if="researcher">
                                {{researcher}}
                            </v-card-subtitle>
                        </v-col>
                        <v-col cols="6" class="">
                            <v-row justify="end" class="mr-1">
                                <v-card-actions>
                                    <v-btn
                                    v-if="!approved"
                                    text 
                                    class="red--text"
                                    @click="backToResearcher(ticketData.id)"
                                    >
                                        やり直す
                                    </v-btn>
                                    <v-btn
                                    v-if="!approved"
                                    text 
                                    class="green--text"
                                    @click="payForTheTicket(ticketData.id)"
                                    >
                                        Approve this draft
                                    </v-btn>
                                </v-card-actions>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-card-text>
                        リサーチャーからのレポート
                    </v-card-text>
                    <v-card-text v-html="report_draft">
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
/* eslint-disable no-console */
import {db} from '@/fb'
export default {
    name:'researcherDraft',
    props:['ticketData'],
    data(){
        return{
            approved:false,
            report_draft:null,
            researcher:null,
        }
    },
    created(){
        let ref = db.collection('ticket_completed').where('ticket_number','==',this.ticketData.id);
        ref.get().then(snap=>{
            if(!snap.empty){
                snap.forEach(doc=>{
                    this.report_draft = doc.data().report_draft
                    this.researcher = doc.data().submitted_by
                    if(doc.data().pay_for_ticket){
                        this.approved = true
                    }else{
                        this.approved = false
                    }
                })
            }
        })
    },
    methods:{
        payForTheTicket(ticket_number){
            if(confirm("Are you sure you want to approve the payment for this ticket?")){
                let date = new Date();
                let currentMonthYear = String(date.getMonth()+1)+'/'+date.getFullYear();
                let ref = db.collection('ticket_completed').where('ticket_number','==',ticket_number);
                ref.get().then(snap=>{
                    if(!snap.empty){
                        snap.forEach(doc=>{
                            db.collection('ticket_completed').doc(doc.id).set({
                                pay_for_ticket:true,
                                hand_in_time:currentMonthYear
                            },{ merge: true })
                            .then(
                                alert("You have approved the payment!"),
                                location.reload()
                            )
                            .catch(err=>{
                                console.log(err)
                            })
                        })
                    }
                })
            }else{
                alert("Cancelled!")
            }
        },
        backToResearcher(ticket_number){
            if(confirm("リサーチャーが編集できるようになります。")){
                let ref = db.collection('ticket_editing').where('ticket_number','==',ticket_number);
                ref.get().then(snap=>{
                    if(!snap.empty){
                        snap.forEach(doc=>{
                            db.collection('ticket_editing').doc(doc.id).set({
                                submitted:false
                            },{ merge: true })
                            .then(
                                alert("プロセスが完了しました！")
                            )
                            .catch(err=>{
                                console.log(err)
                            })
                        })
                    }
                })
            }else{
                alert("キャンセルしました!")
            }
        }
    }
}
</script>